import { css } from "@emotion/core"

/* stylelint-disable */
export default {
    hide: () => css`
        text-indent: 100%;
        white-space: nowrap;
        overflow: hidden;
    `,
}
